<template>
  <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-center justify-center min-h-screen p-4">
      <div class="bg-white w-full max-w-xl rounded-lg shadow-xl p-6 relative">
        <button
          @click="closeModal"
          class="absolute top-2 right-2 text-gray-600 hover:text-gray-800 focus:outline-none"
        >
          <svg
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <h3 class="text-2xl font-semibold text-gray-800 mb-4">
          Edit Vacancy
        </h3>
        <div v-if="vacancy">
          <form @submit.prevent="submitForm">
            <div class="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label
                  for="jobTitle"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  >Job title<span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  id="jobTitle"
                  v-model="formData.jobTitle"
                  required
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label
                  for="company"
                  class="block text-sm font-medium text-gray-700 mb-1"
                >Company<span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  id="company"
                  :value="companyName"
                  readonly
                  disabled
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label
                  for="workplaceType"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  >Workplace type<span class="text-red-500">*</span></label
                >
                <select
                  id="workplaceType"
                  v-model="formData.workplaceType"
                  required
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Onsite">Onsite</option>
                  <option value="Hybrid">Hybrid</option>
                  <option value="Remote">Remote</option>
                </select>
              </div>
              <div>
                <label
                  for="employeeLocation"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  >Employee location<span class="text-red-500">*</span></label
                >
                <input
                  type="text"
                  id="employeeLocation"
                  v-model="formData.employeeLocation"
                  required
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div>
                <label
                  for="jobType"
                  class="block text-sm font-medium text-gray-700 mb-1"
                  >Job type<span class="text-red-500">*</span></label
                >
                <select
                  id="jobType"
                  v-model="formData.jobType"
                  required
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Full time">Full-time</option>
                  <option value="Part time">Part-time</option>
                  <option value="Contract">Contract</option>
                  <option value="Temporary">Temporary</option>
                  <option value="Other">Other</option>
                  <option value="Volunteer">Volunteer</option>
                  <option value="Internship">Internship</option>
                </select>
              </div>
              <div>
                <label
                  for="status"
                  class="block text-sm font-medium text-gray-700 mb-1"
                >Status</label
                >
                <select
                  id="status"
                  v-model="formData.status"
                  required
                  class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  <option value="Activa">Activa</option>
                  <option value="No Activa">No Activa</option>
                  <option value="Cerrada">Cerrada</option>
                </select>
              </div>
            </div>
            <div class="mb-4">
              <label
                for="description"
                class="block text-sm font-medium text-gray-700 mb-1"
              >Description<span class="text-red-500">*</span></label
                >
              <textarea
                id="description"
                v-model="formData.description"
                rows="6"
                required
                class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>
            <div class="mb-4">
              <label
                for="comments"
                class="block text-sm font-medium text-gray-700 mb-1"
                >Comments</label
              >
              <textarea
                id="comments"
                v-model="formData.comments"
                rows="4"
                class="mt-1 p-2 w-full border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              ></textarea>
            </div>

            <div class="flex justify-end mt-6">
              <button
                type="submit"
                class="bg-blue-500 hover:bg-blue-700 text-white py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Update Vacancy
              </button>
            </div>
          </form>
        </div>
        <div v-else>
          <p class="text-gray-700 mb-2">Vacancy information not available.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
import { signInWithCustomToken } from "firebase/auth";

async function getCustomTokenFromBackend(firebaseIdToken) {
  try {
    const response = await fetch("/api/get-custom-token", {
      // Replace with your backend URL
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ firebaseIdToken }),
    });
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(
        `Failed to fetch custom token: ${response.status} ${JSON.stringify(
          errorData
        )}`
      );
    }
    const data = await response.json();
    if (!data.customToken) {
      throw new Error(
        `Failed to fetch custom token, missing token ${JSON.stringify(data)}`
      );
    }
    return data.customToken;
  } catch (error) {
    console.error("Error getting the custom token:", error);
    throw error;
  }
}

export default {
  props: {
    isOpen: Boolean,
    vacancy: Object,
  },
  data() {
    return {
      formData: {
        jobTitle: "",
        workplaceType: "Onsite",
        employeeLocation: "",
        jobType: "Full time",
        description: "",
        status: "",
        comments: "",
      },
      companyName: "",
    };
  },
  async created() {
    if (this.vacancy) {
      this.formData = {
        jobTitle: this.vacancy.title || "",
        workplaceType: this.vacancy.workplaceType || "Onsite",
        employeeLocation: this.vacancy.employeeLocation || "",
        jobType: this.vacancy.jobType || "Full time",
        description: this.vacancy.description || "",
        status: this.vacancy.status || "Activa",
        comments: this.vacancy.comments || "",
      };
      try {
        // 1. Get the Firebase ID token (original)
        const firebaseIdToken = await auth.currentUser.getIdToken();
        // 2. Get the custom token from backend
        const customToken = await getCustomTokenFromBackend(firebaseIdToken);
        // 3. Authenticate with custom token using signInWithCustomToken
        await signInWithCustomToken(auth, customToken);
        // 4. Get the token to use in the Authorization header (use firebase.auth().currentUser.getIdToken())
        const token = await auth.currentUser.getIdToken();
        // Fetch Company Info (name)
        const companyResponse = await fetch("/api/company-names", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!companyResponse.ok) {
          throw new Error(
            `HTTP error! status: ${companyResponse.status}`
          );
        }
        const companyData = await companyResponse.json();
        this.companyName = companyData[0]?.name;
      } catch (error) {
        console.error("Error getting company name", error);
        this.companyName = "Error";
      }
    }
  },
  methods: {
      async submitForm() {
      try {
            // 1. Get the Firebase ID token (original)
            const firebaseIdToken = await auth.currentUser.getIdToken();
            // 2. Get the custom token from backend
            const customToken = await getCustomTokenFromBackend(firebaseIdToken);
            // 3. Authenticate with custom token using signInWithCustomToken
             await signInWithCustomToken(auth, customToken);
            // 4. Get the token to use in the Authorization header (use firebase.auth().currentUser.getIdToken())
             const token = await auth.currentUser.getIdToken();

          const response = await fetch(`/api/update-vacancy/${this.vacancy.id}`, {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.formData),
          });

          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(
              `HTTP error! status: ${response.status} ${JSON.stringify(
                errorData
              )}`
            );
          }

          const responseData = await response.json();
          console.log("Vacancy updated successfully:", responseData);
          alert("Vacancy Updated!");
          this.$emit("vacancy-updated");
          this.closeModal();
        } catch (error) {
          console.error("Error updating vacancy:", error);
          alert(`Error updating vacancy: ${error.message}`);
        }
      },
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>